import { useEffect, useState } from "react";
import { debounce } from "src/utils";

interface UseLoadingProps {
  isLoading: boolean;
  timeout?: number;
  loadingOnInit?: boolean;
}
export const useLoading = (props: UseLoadingProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(props.loadingOnInit || false);

  useEffect(() => {
    if (props.isLoading) {
      setIsLoading(true);
    } else {
      props.timeout ? debounce(props.timeout || 0, () => setIsLoading(false))() : setIsLoading(false);
    }
  }, [props.isLoading, props.timeout]);

  return {
    isLoading,
  };
};
